import { LOCALES } from 'config/constants/locales';

const getContentfulLocale = (locale?: string): string => {
  return locale ?? LOCALES.DE;
};

// for the initial call we need to make sure to pass no locale for DE-CH, EN and NL because they are not always translated
// TODO: looks more like a hack, lets try to find another solution
const getInitialContentfulLocale = (locale?: string): string | undefined => {
  if (locale === LOCALES.CH || locale === LOCALES.EN || locale === LOCALES.NL) {
    return undefined;
  }

  return locale;
};

/** Get the locale for the global data. EN has no global data of its own, it is served from DE. */
const getContentfulGlobalDataLocale = (locale?: string): string => {
  if (locale === undefined || locale === LOCALES.EN) {
    return LOCALES.DE;
  }

  return locale;
};

export { getContentfulGlobalDataLocale, getInitialContentfulLocale };

export default getContentfulLocale;
